/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Remove_Color_Formatting_DescInputs */



/**
* | output |
* | --- |
* | "Removes color and background color without deleting the text" |
*
* @param {Remove_Color_Formatting_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const remove_color_formatting_desc = /** @type {((inputs?: Remove_Color_Formatting_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Remove_Color_Formatting_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprime la couleur et la couleur de fond sans supprimer le texte")
	if (locale === "de") return /** @type {LocalizedString} */ ("Entfernt Schrift- und Hintergrundfarbe, ohne den Text zu löschen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuove il colore e il colore di sfondo senza eliminare il testo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удаляет цвет текста и фона, не удаляя сам текст")
	if (locale === "es") return /** @type {LocalizedString} */ ("Elimina el color y el color de fondo sin borrar el texto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("移除文字颜色和背景颜色，但不删除文本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テキストを削除せずに文字色と背景色を削除します")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पाठ को हटाए बिना रंग और पृष्ठभूमि रंग हटाता है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Remove a cor e a cor de fundo sem eliminar o texto")
	return /** @type {LocalizedString} */ ("Removes color and background color without deleting the text")
});